import styles from "./Labels.module.css";

const SectionHeader = ({ text }) => {
  return <p className={styles.sectionHeader}>{text}</p>;
};

export default SectionHeader;
